import Modal from "../../scripts/modal";
import SiteMessagesInstance from "../../components/site-messages";
import merge from "lodash.merge";

const modalDeleteAccountsGroup = (settings = {}) => {

  settings = merge({
    class: ['group-modal', 'form-modal'],
    title: 'Delete Group',
  }, settings)

  const group = settings.group;

  const modal = new Modal(settings);

  modal.setContent(`

    <form data-form="delete_sub_account" class="grid-container">
        
    <div class="grid-x grid-margin-x form-modal__row">
      <div class="cell medium-2">Name</div>
      <div class="cell medium-8">
        <p class="text--bold">${group.group_name}</p>
      </div>
    </div>
    
    <p>You are about to delete this group, this action cannot be undone.</p>
    <p style="margin-bottom: 20px;">This group should not have any assigned sensors or children groups.</p>

    <div class="form-modal-actions">
      <div class="form-modal-actions__submit">
        <button type="submit" class="button button--red" style="margin-right: 20px;" data-for="okay">Delete Group</button>
        <button type="button" class="button gray" data-for="cancel">Cancel</button>
        <div class="error-message">Hello I'm an error</div>
      </div>
    </div>
    </form>
  `);

  const $modalContainer = $(modal.getContainer());

  const $form = $modalContainer.find('form');
  const $error = $modalContainer.find('.error-message');

  $form.on('submit', e => {

    e.preventDefault();
    $form[0].disabled = true;

    $error.removeClass('is-visible');

    window.apiRequest('post', `/groups/sensors/${group.id}/delete`).then(async r => {

      $form[0].disabled = false;

      if (r.type === 'error') {

        $error.html(r.message);
        $error.addClass('is-visible');

      } else {
        SiteMessagesInstance.addMessage('success', r.message);
        SiteMessagesInstance.displayMessages();

        // Pass parent_id (or 0) in the event detail
        const parentId = group.parent_id || 0;
        const evt = new CustomEvent('groupDeleted', { detail: { parent_id: parentId } });
        document.dispatchEvent(evt);

        modal.close();
      }

    });

  });

  $modalContainer.on('click', '.button[data-for="cancel"]', () => {
    modal.close();
  });

  modal.open();

}

export default modalDeleteAccountsGroup;
